import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder,UntypedFormGroup,FormControl } from '@angular/forms';
import {ExamsService} from '../exams.service';
import {AutotextService} from '../autotext.service';
import { LoginService } from '../login.service';
import { PatientsService } from '../patients.service';

@Component({
    selector: 'app-gyngeneral',
    templateUrl: './gyngeneral.component.html',
    styleUrls: ['./gyngeneral.component.scss'],
    standalone: false
})
export class GYNgeneralComponent implements OnInit {
  GenForm: UntypedFormGroup;
  lastMed: string;

  aiSummaryLoading = false;
  constructor(private fb:UntypedFormBuilder, public es: ExamsService,public atS:AutotextService,
    public ls: LoginService, private patService: PatientsService) {
    this.GenForm = this.fb.group({
      MedicalHistory: [''],
      Purpose: [''],
      LMP:  [''],
      Gravida:[''],
      Para:[''],
      Abortion:[''],

    });
    if(! this.es.isClosed){
      this.es.getLastHistory(true).subscribe((data)=>{
        this.lastMed = data['history'];
      },(err)=>{
        console.log(err);
      });
    }
   }

  ngOnInit() {
    this.es.fillForm(this.GenForm,"GYNgeneral",false,true);
  }

  days():number{
    if(! this.GenForm.get('LMP').value)
      return null;
    let now  = new Date();
    let lmp  = new Date(this.GenForm.get('LMP').value)
    return Math.floor((now.getTime() - lmp.getTime()) / (24*60 * 60 *1000));
  }

  addLastMed(){
    if(this.GenForm.get("MedicalHistory").value)
      this.GenForm.get("MedicalHistory").setValue(this.GenForm.get("MedicalHistory").value + this.lastMed);
    else
      this.GenForm.get("MedicalHistory").setValue(this.lastMed);
  }

  // AR-24 change 3: AI medical-history summary from the patient's answered questionnaire.
  getAiSummary() {
    if (this.aiSummaryLoading) return;
    this.aiSummaryLoading = true;
    this.es.getAiSummary(this.es.ExamType, this.patService.getPat()?.PID).subscribe(
      (res: any) => {
        this.aiSummaryLoading = false;
        if (res && res.summary) {
          const control = this.GenForm.get('MedicalHistory');
          const existing = (control.value || '').toString().trim();
          const previous = (res.previousSummary || '').toString().trim();
          // Replace only our own previously-pasted AI block (exact match), so a
          // doctor's hand-typed notes are never overwritten; otherwise append.
          if (previous && existing === previous) {
            control.setValue(res.summary);
          } else {
            control.setValue(existing ? existing + '\n\n' + res.summary : res.summary);
          }
        } else if (res && res.reason) {
          alert('Could not generate a summary (' + res.reason + ').');
        }
      },
      () => {
        this.aiSummaryLoading = false;
      }
    );
  }

}
